import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { InputSwitch } from "primereact/inputswitch"
import { useTranslation } from "react-i18next"

export const DepartamentoItem = ({
  entry,
  deleteDepartamentoItem,
  handleStatusResponsable,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div
      key={entry?.id}
      className='list-departamentos__item'
    >
      <p className='name'>{entry?.nombre}</p>
      <div className='list-departamentos__item-actions'>
        <p>{t("gestionUsuarios.users.departamentItem.labelResponsible")}</p>
        <InputSwitch
          checked={entry?.esResponsable}
          onChange={() =>
            handleStatusResponsable(
              entry?.departamentoId ?? entry.id,
              !entry?.esResponsable
            )
          }
        />
        <FontAwesomeIcon
          onClick={() =>
            deleteDepartamentoItem(entry?.departamentoId ?? entry?.id)
          }
          icon={["fal", "xmark"]}
          // @ts-expect-error TS(2322): Type '"big"' is not assignable to type 'SizeProp |...
          size='big'
        />
      </div>
    </div>
  )
}
